export default "__VITE_ASSET__a7ae3239__"